// import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
    return localStorage.getItem(TokenKey)
    // return Cookies.get(TokenKey)
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token)
    // return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return localStorage.removeItem(TokenKey)
    // return Cookies.remove(TokenKey)
}

export function authorize() {
    // 微信授权登录
    let redirect_uri = encodeURIComponent('https://2405-csqipei-pc.gepai.tech/mobile/login/getUserInfo')
    let appid = "wxddf369a4e755750f";
    let wx_url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    window.location.href = wx_url;
}

